import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CTASection() {
  return (
    <section className="py-20 md:py-32 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-primary/80 -z-10" />
      <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-accent/20 blur-3xl -z-10" />
      <div className="absolute bottom-0 left-0 h-64 w-64 rounded-full bg-primary-foreground/10 blur-3xl -z-10" />

      <div className="container text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
          Ready to put your store on autopilot?
        </h2>
        <p className="text-lg text-primary-foreground/80 mb-8 max-w-xl mx-auto">
          Start optimizing your WooCommerce store today with the power of AI.
        </p>
        <Button
          size="lg"
          variant="secondary"
          className="bg-background text-primary hover:bg-background/90"
          asChild
        >
          <Link to="/signup">
            Start Free - No Credit Card
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
        <p className="mt-4 text-sm text-primary-foreground/60">
          Forever free plan available. Upgrade when you're ready.
        </p>
      </div>
    </section>
  );
}
